module.exports = __webpack_public_path__ + "img/enterprise-icon.40275780.png";